
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Auction_Completed_Winner = class Notification_Auction_Completed_Winner {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _denied_modal_init = false;
    static _denied_modal_action = null;

    static hide_this_variations_details() {
        $("#completed-public-modal-did-win-text").hide();
        $("#completed-public-modal-did-win-details").hide();
        $("#completed-public-modal-did-win-hr").hide();
        $("#completed-public-modal-looking-more-link-container-public").append($(".completed-public-modal-looking-more-link"));
    }

    $modal() {
        return $("#ac-modal-auction-completed-public-modal");
    }

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {

        let deferred = $.Deferred();

        this.$modal().data('deferred', deferred);

        _.Notification_Auction_Completed_Loser.hide_this_variations_details();

        let $details = $("#completed-public-modal-did-win-details");

        $details.empty();

        let meta;

        try {
            meta = JSON.parse(this.notification.meta)
        } catch (e) {
        }

        $("#completed-public-modal-did-win-text").show();
        $("#completed-public-modal-looking-more-link-container-participant").append($(".completed-public-modal-looking-more-link"));
        $("#completed-public-modal-did-win-hr").show();

        $("#completed-public-modal-am-name").text(meta.am_name);
        $("#completed-public-modal-am-phone").empty().append($("<a></a>").attr('a', 'tel:' + meta.am_phone).text(_.formatPhoneNumber(meta.am_phone)));
        $("#completed-public-modal-am-email").empty().append($("<a></a>").attr('a', 'mailto:' + meta.am_email).text(meta.am_email));
        this.$modal().find('.btn-show-auction-summary').show();

        /* --- Determine which items the winner won, sorted by not number --- */

        let registrant = await _.AuctionUI_Session.get_registrant();
        if (!registrant) {
            _.shouldnt_happen();
            return;
        }

        try {
            let auction = await _.ac_state.auction.private();

            let property = await auction.property.fetch_private();

            $details.append($("<div></div>")
                .text(property.title)
                .attr('style', 'font-size: 22px; color:#022a6b; font-weight: bold; line-height:24px;')
            );

            let items = await auction.auction_items.fetch_private();
            let items_won = [];

            console.log(property);
            console.log(items);

            for (let item of items) {
                if (!item.auction_round_id) {
                    continue;
                }

                let round = await item.auction_round.fetch_private();
                if (!round) {
                    continue;
                }

                if (round.status != App_Models_AuctionRound.STATUS_SOLD) {
                    continue;
                }

                let bid = await round.current_bid.fetch_private();
                if (!bid) {
                    continue;
                }

                if (bid.registrant_id == registrant.id) {
                    items_won.push(item);
                }
            }

            items_won.sort((a, b) => a.lot_number - b.lot_number);

            for (let item of items_won) {
                $details.append($("<div></div>")
                    .text("Lot " + item.lot_number + ": " + item.title)
                    .attr('style', 'font-size: 17px; color:#022a6b; line-height:18px; margin-top: 15px;')
                );
            }

            // Todo: open loser modal if none found?

        } catch (e) {
            console.error(e);
        }

        this.$modal().modal_show();

        // Wait for the modal to close.
        await deferred.promise();

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
    }

    async on_hide() {
    }

}